var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.2C8.942 3.2 3.2 8.942 3.2 16c0 7.058 5.742 12.8 12.8 12.8 7.058 0 12.8-5.742 12.8-12.8 0-7.058-5.742-12.8-12.8-12.8Zm4.634 16.043a.984.984 0 1 1-1.392 1.392L16 17.393l-3.242 3.242a.985.985 0 0 1-1.392-1.392L14.607 16l-3.241-3.242a.984.984 0 0 1 1.392-1.392L16 14.608l3.242-3.242a.985.985 0 0 1 1.392 1.392L17.393 16l3.241 3.243Z",
    fill: "#fff"
  })));
};
export default SvgIconClose;